
import { defineComponent } from 'vue'
import { useAxiosRecord } from '@/axios/index.ts'
import { isValid } from '@/classes/ChekType.ts'
export default defineComponent({
  name: 'Coupon',
  props: {
    groupId: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { state: recordState } = useAxiosRecord(2, props.groupId)
    function copyKey(event: any, code: string) {
      event.target.parentNode.childNodes[0].select()
      document.execCommand('copy')
      window.MobileApp.call(code, 'copy')
    }
    return {
      copyKey,
      recordState,
      isValid
    }
  }
})
